module.exports = __webpack_public_path__ + "static/media/signature.11999965.svg";